import { toastr } from 'react-redux-toastr'
import * as ActionTypes from '../../actions/actionTypes'
import * as actions from '../../actions/hotels24actions'
import { getParser } from '../../adapters'
import { urlParams } from '../../utils/mainUtils'
import { handleError, handleResponse, securedFetch, showImportRatesToastr } from '../apiUtils'
import * as urls from '../urls'

/** @thunk **/
export const fetchH24Rates = params => (dispatch, getState) => {
    dispatch({ type: ActionTypes.H24_RATES_FETCH_REQUEST })
    const { auth } = getState()

    securedFetch(urlParams(urls.h24RatesFind, params), auth, { method: 'GET' })
        .then(handleResponse)
        .then(json => dispatch(actions.h24_fetchRatesSuccess(getParser(urls.h24Rates)(json))))
        .catch(
            handleError(
                dispatch,
                actions.h24_fetchRatesFailure,
                'Что-то пошло не так!',
                'При получении тарифов произошла ошибка'
            )
        )
}

/** @thunk **/
export const postH24Rate = payload => (dispatch, getState) => {
    const opts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
    }
    const { auth } = getState()

    securedFetch(urls.h24Rates, auth, opts)
        .then(handleResponse)
        .then(json => dispatch(actions.h24_saveRatesSuccess(json)))
        .catch(
            handleError(
                dispatch,
                actions.h24_saveRatesFailure,
                'Что-то пошло не так!',
                'При сохранении тарифов произошла ошибка'
            )
        )
}

/** @thunk **/
export const deleteH24Rate = remoteId => (dispatch, getState) => {
    const { auth } = getState()

    securedFetch(urls.h24RateSelf(remoteId), auth, { method: 'DELETE' })
        .then(handleResponse)
        .then(() => dispatch(actions.h24_deleteRateSuccess(remoteId)))
        .then(() => toastr.success('Тариф удален'))
        .catch(
            handleError(
                dispatch,
                actions.h24_deleteRateFailure,
                'Что-то пошло не так!',
                'При удалении тфрифа произошла ошибка'
            )
        )
}

/** @thunk **/
export const importH24Rates = () => (dispatch, getState) => {
    const { h24CurrentOrganization } = getState()
    const { auth } = getState()

    const opts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ organizationId: h24CurrentOrganization })
    }

    securedFetch(urls.reloadRatesFromH24, auth, opts)
        .then(handleResponse)
        .then(showImportRatesToastr)
        .then(json => dispatch(actions.h24_importRatesSuccess(getParser(urls.reloadRatesFromH24)(json))))
        .catch(
            handleError(
                dispatch,
                actions.h24_importRatesFailure,
                'Что-то пошло не так!',
                'При импорте тарифов произошла ошибка'
            )
        )
}



// WEBPACK FOOTER //
// ./src/api/h24Api/h24Rates.js